export default {
  publicConfig: '/Djhome/public_config',
  login: '/Djlogin/tologin',
  userInfo: '/Djusers/usersinfo',
  categoryList: '/Djdrama/catelist',
  list: '/Djdrama/listdata',
  collect: '/Djconsumer/tocollect',
  collectList: '/Djdrama/browselist',
  record: '/Djconsumer/browse_record',
  lockFind: '/Djpay/lockfind',
  dataUp: '/Dataanalysis/dataup'
}

export const baseUrl = 'https://story.storyrushtv.com/api'
// export const baseUrl = '/api'